
/// <amd-module name="TestPlanCommon/Contracts/TestPlanWebContracts" />
import * as TestPlanContracts from "TestPlanCommon/Contracts/TestPlan";

/**
 * Contains the properties of test points 
 */


export interface ITestPointGridDisplayColumn {
    name: string;
    text: string;
    fieldId: number;
    canSortBy: boolean;
    width: number;
    index: string;
    type: string;
    isIdentity: boolean;
}

/**
 * Contains the properties of column order. 
 */
export interface IColumnSortOrderModel {
    index: string;
    order: string;
}

/**
 * Contains the properties of column settings. 
 */
export interface IColumnSettingModel {
    refName: string;
    width: number;
}

/**
 * Contains the properties of a test point. 
 * TODO: Clean up this interface
 */
export interface ITestPointModel {
    testPointId: number;
    testCaseId: number;
    title: string;
    tester: string;
    priority: number;
    configurationId: number;
    configurationName: string;
    automated: boolean;
    outcome: TestPlanContracts.Outcome;
    state: TestPlanContracts.PointState;
    mostRecentRunId: number;
    mostRecentResultOutcome: TestPlanContracts.Outcome;
    lastResultState: TestPlanContracts.ResultState;
    assignedTo: string;
    sequenceNumber: number;
}


/**
 * Contains the properties of a test plan hub data. 
 */
export interface ITestPlanHubDataModel {
    testPlan: ITestPlanModel;
    testSuites: ITestSuiteModel[];
    testPoints: ITestPointModel[];
    selectedSuiteId: number;
    totalTestPoints: number;
}

/**
 * Contains the properties of a response returned by the data provider. 
 */
export interface IJsonResponse {
    testPlanHubData: ITestPlanHubDataModel;
    columnSortOrder: IColumnSortOrderModel;
    testPlanDefaultQuery: string;
    columnOptions: ITestPointGridDisplayColumn[];
    pagedColumns: ITestPointGridDisplayColumn[];
    isAdvancedTestExtensionEnabled?: boolean;
}

export interface IParent {
   id: number;
}

/**
 * Contains the properties of a test suite. 
 */
export interface ITestSuiteModel {
    id: number;
    revision: number;
    descendantSuiteIds: number[];
    children: ITestSuiteModel[];
    name: string;
    parent: IParent
    // Filtered/Visible points in a suite
    pointCount: number;
    suiteType: string;
    requirementId: number;
    parentSuiteId: number;
    queryText: string;
    status: string;
    //Total Points in a suite
    totalPointCount: number;
    configurations: number[];
}

/**
 * Contains the properties of a test plan. 
 */
export interface ITestPlanModel {
    id: number;
    name: string;
    rootSuite: ITestSuiteModel;
    area: IArea;
    areaPath: string;
}

export interface IArea {
    name: string;
    id : string;
}

/**
 * Contains the properties of a test case. 
 */
export interface ITestCaseWithParentSuite {
    id: number;
    suiteId: number;
    suiteName: string;
}
